import { useState } from "react";
import { ApiError } from "@/lib/api";
import { downloadCsv } from "@/lib/staff-payments";
import { SECONDARY_BUTTON } from "./buttons";

interface DownloadCsvButtonProps {
  /** Fetches every row and returns the CSV text. */
  build: () => Promise<string>;
  filename: () => string;
}

/** "Download CSV": the list as it is filtered and sorted, every page. */
export function DownloadCsvButton({ build, filename }: DownloadCsvButtonProps): React.ReactElement {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function download(): Promise<void> {
    setBusy(true);
    setError(null);
    try {
      downloadCsv(filename(), await build());
    } catch (e) {
      setError(
        e instanceof ApiError && e.code === "EXPORT_TOO_LARGE"
          ? "Too many rows to download (more than 5,000). Narrow the list first."
          : "The download could not be prepared. Try again.",
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <button type="button" disabled={busy} onClick={() => void download()} className={SECONDARY_BUTTON}>
        {busy ? "Preparing…" : "Download CSV"}
      </button>
      {error && (
        <p role="alert" className="text-sm text-red-800">
          {error}
        </p>
      )}
    </div>
  );
}
